<template>
  <div style="margin: 0 30px;padding-bottom: 20px">
    <div style="height: 40px">
      <el-date-picker v-fixZoom size="small" :clearable="false" v-model="sendDate" type="daterange" unlink-panels range-separator="至"
                      start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd" style="margin-right: 10px; width: 360px">
      </el-date-picker>
      <el-button size="small" type="primary" @click="getTableHistoryHealthPerson">查询</el-button>
    </div>
    <el-table height="320px" size="small" :data="tableData" border highlight-current-row ref="singleTable">
      <el-table-column
        type="index"
        label="编号"
        width="70"
        align="center">
      </el-table-column>
      <el-table-column
        prop="gaoVal"
        label="收缩压"
        min-width="70"
        align="center">
      </el-table-column>
      <el-table-column
        prop="diVal"
        label="舒张压"
        min-width="70"
        align="center">
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="测量时间"
        min-width="90"
        align="center">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import {queryhealthquerypersonhistory} from '../../../api/yanglaoyuan'

export default {
  name: 'bloodPressure',
  props: {
    IDs: {
      type: Object,
      default: null
    },
    personRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      tableData: [],
      tableDataHistory: [],
      sendDate: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  created () {
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    let end = new Date().format('yyyy-MM-dd')
    const start = this.commonType.GetDateStr(-7)
    this.sendDate = [start.format('yyyy-MM-dd'), end]
    this.getTableHistoryHealthPerson()
  },
  methods: {
    getTableHistoryHealthPerson () {
      this.healthTypeList = []
      let params = {
        size: 9999,
        page: 1
      }
      let data = {
        'epid': this.personRow.id,
        'pid': 0,
        'from': this.sendDate[0] + ' 00:00:00',
        'to': this.sendDate[1] + ' 23:59:59',
        'eid': this.$store.state.user.LoginResp.entity_id
      }
      queryhealthquerypersonhistory(params, data).then(res => {
        this.tableDataHistory = res.data.healthdata
        this.getDataEnd()
      })
    },
    getDataEnd () {
      let vm = this
      let xueya = []
      let diya = []
      this.tableDataHistory.forEach(item => {
        if (item.health_key_id === vm.IDs.gaoId) {
          item.gaoVal = item.health_value
          item.diVal = ''
          xueya.push(item)
        } else if (item.health_key_id === vm.IDs.diId) {
          diya.push(item)
        }
      })
      for (let i = 0; i < xueya.length; i++) {
        diya.forEach(item => {
          if (xueya[i].create_time === item.create_time) {
            xueya[i].diVal = item.health_value
          }
        })
      }
      this.tableData = xueya
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/bloodPressure.vue